import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=69e277d7&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=69e277d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e277d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e277d7')) {
      api.createRecord('69e277d7', component.options)
    } else {
      api.reload('69e277d7', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=69e277d7&scoped=true", function () {
      api.rerender('69e277d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/detail.vue"
export default component.exports